export const translocoLang = 'translocoLang';
/**
 * Mounts transloco language pattern
 * When the response from back-end is 'pt' it must be changed to 'pt-BR'
 * @param {string} language
 * @return {string}
 */
export function setTranslocoLang(language: string) {
  return language === 'pt' ? language + '-BR' : language;
}
